import {ENDPOINTS} from '../common/endpoints';
import {CreateItemRequest, ItemDto, ItemLightDto, UpdateItemRequest} from '../models/Items/IItem';
import {baseAPI} from './BaseAPI';
import {TAGS} from "./TagTypes";

// TODO: move types to modals folder
type SearchPropsType = {
    page: number;
    limit: number;
    searchPhrase: string;
    sortBy: string;
    descending: boolean;
};

type SearchResponseType = {
    data: ItemDto[];
    page: number;
    pageCount: number;
    pageSize: number;
    totalCount: number;
};

export const itemAPI = baseAPI.injectEndpoints({
    endpoints: (build) => ({

        getItemsByPages: build.query<SearchResponseType, SearchPropsType>({
            query: ({
                        page,
                        limit,
                        searchPhrase,
                        sortBy,
                        descending,
                    }: SearchPropsType) => ({
                url: ENDPOINTS.ITEMS.V2,
                method: 'GET',
                params: {page, limit, searchPhrase, sortBy, descending},
            }),
            providesTags: (result) => ['Item'],
        }),

        getItemById: build.query<ItemDto, string>({
            query: (id) => ({
                url: `${ENDPOINTS.ITEMS.V2}/${id}`,
                method: 'GET',
            }),
            providesTags: (result) => ['Item'],
        }),

        getAllItemsV2: build.query<ItemDto[], {includeDeleted?: boolean} | void>({
            query: (args) => ({
                url: ENDPOINTS.ITEMS.V2_ALL,
                method: 'GET',
                params: {includeDeleted: args?.includeDeleted ?? false},
            }),
            providesTags: [TAGS.ITEM, {type: TAGS.ITEM, id: 'LIST'}],
        }),

        getAllItemsV2Light: build.query<ItemLightDto[], void>({
            query: () => ({url: ENDPOINTS.ITEMS.V2_ALL_LIGHT, method: 'GET'}),
            providesTags: [TAGS.ITEM, {type: TAGS.ITEM, id: 'LIST'}],
        }),

        createItem: build.mutation<ItemDto, CreateItemRequest>({
            query: (newItem) => ({
                url: ENDPOINTS.ITEMS.V2,
                method: 'POST',
                body: newItem,
            }),

            invalidatesTags: [TAGS.ITEM, TAGS.AVAILABLE_ITEM_NAMES, TAGS.RECIPES, TAGS.RECIPE, TAGS.FILLINGS, TAGS.FILLING, TAGS.DECORATIONS, TAGS.DECORATION, TAGS.RECIPES_FOR_ORDER],
        }),

        deleteItem: build.mutation<void, string>({
            query: (id) => ({
                url: `${ENDPOINTS.ITEMS.V2}/${id}`,
                method: 'DELETE',
            }),

            invalidatesTags: [TAGS.ITEM, TAGS.AVAILABLE_ITEM_NAMES, TAGS.RECIPES, TAGS.RECIPE, TAGS.FILLINGS, TAGS.FILLING, TAGS.DECORATIONS, TAGS.DECORATION, TAGS.RECIPES_FOR_ORDER],
        }),

        updateItem: build.mutation<ItemDto, {id: string; body: UpdateItemRequest}>({
            query: ({id, body}) => ({
                url: `${ENDPOINTS.ITEMS.V2}/${id}`,
                method: 'PUT',
                body,
            }),

            invalidatesTags: [TAGS.ITEM, TAGS.AVAILABLE_ITEM_NAMES, TAGS.RECIPES, TAGS.RECIPE, TAGS.FILLINGS, TAGS.FILLING, TAGS.DECORATIONS, TAGS.DECORATION, TAGS.RECIPES_FOR_ORDER],
        }),

        getAvailableItemNames: build.query<string[], void>({
            query: () => ({
                url: ENDPOINTS.ITEMS.GET_AVAILABLE_ITEM_NAMES,
                method: 'GET',
            }),
            providesTags: [TAGS.AVAILABLE_ITEM_NAMES],
        }),
    }),
});
